import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import(/* webpackChunkName: "home" */ '../views/Home.vue'),
    meta: { layout: 'app' }
  },

  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "jurnal" */ '../views/About.vue'),
    meta: { layout: 'app' }
  },

  {
    path: '/jurnal',
    name: 'jurnal',
    component: () => import(/* webpackChunkName: "jurnal" */ '../views/jurnal/Jurnal.vue'),
    meta: { layout: 'app' }
  },
  {
    path: '/jurnal/show/:id',
    name: 'jurnal-single',
    component: () => import(/* webpackChunkName: "jurnalsingle" */ '../views/jurnal/Jurnal-single.vue'),
    meta: { layout: 'app' }
  },

  {
    path: '/kamus',
    name: 'kamus',
    component: () => import(/* webpackChunkName: "kamus" */ '../views/kamus/Kamus.vue'),
    meta: { layout: 'app' }
  },
  {
    path: '/kamus/settings',
    name: 'kamus-settings',
    component: () => import(/* webpackChunkName: "kamussetting" */ '../views/kamus/Kamus-settings.vue'),
    meta: { layout: 'app-simple' }
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
